import { DisplayFromFHIRUri } from "./UriEntry";

const DisplayFromFHIRParameterDefinition = ({ parameterDefinition }) => {
    if (parameterDefinition) {
        if (Array.isArray(parameterDefinition) || typeof parameterDefinition != "object") {
            return <>[ERROR: ParameterDefinition data not interpretable.]</>;
        } else {
            return <div style={{ marginLeft: "24px", wordBreak: "break-all" }}>
                {parameterDefinition.name && <><b>Name:</b> {parameterDefinition.name}<br /></>}
                {parameterDefinition.use && <><b>Use:</b> {parameterDefinition.use}<br /></>}
                {(!isNaN(parameterDefinition.min) || parameterDefinition.max) &&
                    <><b>Cardinality: </b>{parameterDefinition.min}-{parameterDefinition.max}<br /></>}
                {parameterDefinition.documentation && <><b>Description:</b> {parameterDefinition.documentation}<br /></>}
                {parameterDefinition.type && <><b>Type:</b> {parameterDefinition.type}<br /></>}
                {parameterDefinition.profile && <><b>Profile:</b> <DisplayFromFHIRUri uri={parameterDefinition.profile} /><br /></>}
            </div>
        }
    } else {
        return <></>
    }
}

export default DisplayFromFHIRParameterDefinition;